<script>
    import { createEventDispatcher } from 'svelte';
    import slugify from 'slugify';
    import Spinner from './Spinner.svelte'
    import { answers } from '../store';

    export let step;
    export let question;
    export let isFinal = false;
    let answer;

    const dispatch = createEventDispatcher();

    function handleSubmit(e) {
        answers.update(n => {
            n[question.name] = {
                taxonomy: question.taxonomy,
                value: answer,
                fake: question.fake
            };
            return n;
        });

        answer = undefined;

        e.target.reset();
    }
</script>


{#if question}
    <div class="dg-question">
        <div class="dg-question__title">
            {question.title}
        </div>

        <form class="dg-question__questions" on:submit|preventDefault={handleSubmit}>
            {#if question.result.length > 0}
                {#each question.result as option}
                    <div class="dg-question__radio">
                        <input
                            bind:group={answer}
                            value={option.slug}
                            type="radio"
                            name={slugify(question.title)}
                            id={option.slug}
                        />
                        <label for={option.slug}>{option.name}</label>
                    </div>
                {/each}
            {:else}
                <div>
                    <Spinner />
                </div>
            {/if}


            {#if answer}
                <div class="dg-question__footer">
                    {#if isFinal}
                        <button type="button" on:click={() => (dispatch('back'))} class="back">
                            Stap terug
                        </button>


                        <button type="submit">
                            Bekijk uw persoonlijke top 3
                        </button>
                    {:else}
                        {#if step > 1}
                            <button type="button" on:click={() => (dispatch('back'))} class="back">
                                Stap terug
                            </button>
                        {/if}
                        <button type="submit">
                            Naar stap {step + 1}
                        </button>
                    {/if}
                </div>
            {/if}
        </form>
    </div>
{/if}


<style lang="scss">
    .dg-question {
        margin: 25px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        &__questions {
            margin: 0 25px;
        }

        &__title {
            font-weight: bold;
            font-size: 16px;
            color: #000;
            margin-bottom: 25px;
        }

        &__footer {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 35px;
        }

        &__radio {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;

            input[type=radio] {
                display: none;
            }

            label {
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            input:checked ~ label::before {
                border: 1px solid #0D78B7;
                background: #0D78B7;
            }

            label::before {
                content: '';
                border-radius: 50%;
                border: 1px solid #979797;
                width: 20px;
                height: 20px;
                margin-right: 25px;
                display: block;
            }
        }
    }
</style>
